export interface MuteOptions {
  mutePseudoClasses?: boolean;
  muteIntercom?: boolean;
}

export function muteConsole({
  mutePseudoClasses = true,
  muteIntercom = true,
}: MuteOptions = {}) {
  if (import.meta.env.MODE !== 'development') {
    return;
  }
  const log = console.error.bind(console);
  const warn = console.warn.bind(console);
  console.error = (...args) => {
    if (
      mutePseudoClasses &&
      args.some(
        (arg) =>
          typeof arg === 'string' &&
          arg.includes('The pseudo class') &&
          arg.includes(
            'is potentially unsafe when doing server-side rendering. Try changing it to',
          ),
      )
    ) {
      return;
    }
    log(...args);
  };
  console.warn = (...args) => {
    if (muteIntercom && args[0].includes('[react-use-intercom]')) {
      return;
    }
    warn(...args);
  };
}
